import { InfoDialog } from './info-dialog';
import { PhoneIcon } from '@phosphor-icons/react';

const REASONS = [
  'Learn more about the Creator Programme',
  'Get personalized help with your AR storytelling projects',
  'Discover tips and best practices for creating immersive experiences',
  'Ask questions and get expert guidance',
];

interface BookCallDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function BookCallDialog({ open, onOpenChange }: BookCallDialogProps) {
  const handleBookCall = () => {
    window.open('https://calendly.com/d/cs9p-7kc-4fv/lureo-creator-competition-30min-call', '_blank');
    onOpenChange(false);
  };

  return (
    <InfoDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Book a Call with Lureo"
    //   description="Connect with the Lureo team to discuss the Creator Competition or get help using Lureo"
      icon={<PhoneIcon weight="duotone" className="h-12 w-12 text-lureo-ink-subtle" />}
      actionButton={{
        label: 'Book a Call',
        onClick: handleBookCall,
        variant: 'secondary'
      }}
      secondaryButton={{
        label: 'Close',
        onClick: () => onOpenChange(false),
        variant: 'outline-3'
      }}
    >
      <div className="space-y-3 text-lureo-14 text-lureo-ink-subtle leading-5">
        <p className="text-center font-semibold">
          Schedule a 30-minute call with our team to:
        </p>
        <ul className="space-y-2 rounded-lureo-radius-lg bg-lureo-surface/60 p-4 pl-6 shadow-lureo-shadow-bar">
          {REASONS.map(reason => (
            <li key={reason} className="flex items-start">
              {/* A dot, not a • character: the accent is a fill, never text */}
              <span aria-hidden className="mr-2.5 mt-2.5 h-1 w-1 shrink-0 rounded-full bg-lureo-accent" />
              <span>{reason}</span>
            </li>
          ))}
        </ul>
      </div>
    </InfoDialog>
  );
}
